export default __webpack_public_path__ + "static/media/wallet.44f712b1.svg";